import { render, staticRenderFns } from "./TaskStoreYuSouList.vue?vue&type=template&id=050b9e04&"
import script from "./TaskStoreYuSouList.vue?vue&type=script&lang=js&"
export * from "./TaskStoreYuSouList.vue?vue&type=script&lang=js&"
import style0 from "./TaskStoreYuSouList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports